<template>
        <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="12">
                        Administración de Roles
                    </v-col>
                    <!--<v-col cols="12" sm="12" md="6">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNuevo"
                        >
                            Crear nuevo
                        </v-btn>
                    </v-col> -->
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>
                <v-data-table
                        :headers="headers"
                        :items="roles"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                    
                        :items-per-page="10"
                        dense
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.id }}</td>
                            <td>{{ item.nombreRol }}</td>
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>




    <!-- Inicio:: Dialog para mostrar los datos del pais-->
    <v-dialog
        v-model="dialog"
        max-width="600px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-account-question-outline</v-icon>
                </v-btn>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                dense
                                v-model="datosRol.nombreRol"
                                label="Nombre del rol"
                                :rules="[
                                    required(
                                        'Nombre del rol'
                                    )
                                ]"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos del pais-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_ROLES, OBTENER_ROL, ACTUALIZAR_ROL } from "@/core/services/store/rol.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";

export default {
    name: "AdminRoles",
    components: {
        SnackAlert,
        DialogLoader
    },
    data() {
        return {
            validForm:false,
            itemName : "Roles",
            dialog: false,
            modalTitle: 'Registrar Rol',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar Rol',
            accion: 1,
            roles: [],
            switchItemEstado: true,
            datosRol: {
                id: 0,
                nombreRol: '',
                usuarioCreacion: 'admin',
                fechaCreacion: '2021-07-23',
                usuarioActaulizacion: 'admin',
                fechaActualizacion: '2021-07-23',
                estadosId: 1
            },
            
            tableLoading: false,
            ...validations
        } 
    }, 
    methods: {
        modalNuevo(){
            this.accion =1;
            this.modalTitle='Registrar Rol';
            this.btnRegistroText='Registrar Rol';
            this.dialog=true;
        },

        resetForm(){
            //this.$refs.form.reset();
             this.datosRol= {
                id: 0,
                nombreRol: '',
                usuarioCreacion: 'admin',
                fechaCreacion: '2021-07-23',
                usuarioActaulizacion: 'admin',
                fechaActualizacion: '2021-07-23',
                estadosId: 1
            };
            this.switchItemEstado=true;
        },

        //!Obtener los roles para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.roles=[];
            
            this.$store
                .dispatch(OBTENER_ROLES)
                .then(() => {
                    this.roles = this.$store.state.rol.roles;
                    this.tableLoading =false;
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosRol.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar Rol';
            this.btnRegistroText='Actualizar Rol';

            this.$store
                .dispatch(OBTENER_ROL, Id)
                .then(res => {
                    if(res.status===200) {
                        this.datosRol = this.$store.state.rol.rol;
                        this.datosRol.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        this.dialog = true;
                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    this.dialogLoaderVisible = false;
                })
                .catch(() => {
                    this.dialogLoaderVisible = false;
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema.');
                });
        },

        registrarItem(){
            //console.log(this.accion)
            this.btnRegistroLoading=true;
            this.switchItemEstado ? this.datosRol.estadosId = 1 : this.datosRol.estadosId = 2;
            if(this.accion===1){
                this.datosRol.id = 0;
                this.$store
                    .dispatch(OBTENER_ROL, this.datosRol)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(() => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema.');
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_ROL, this.datosRol)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(() => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', 'Ha ocurrido un error, por favor, póngase en contacto con un administrador del sistema.');
                        this.btnRegistroLoading=false;
                    });

            }
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Catalogos" },
            { title: "Roles" }
        ]);
    },

    created(){
        this.obtnenerItems();
    },

    
    computed: {
        headers() {
            return [
                {
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                {
                    text: "Nombre del Rol",
                    value: "nombreRol"
                },
                {
                    text: "Estado",
                    value: "estado"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }

    
}
</script>
<style lang="">
    
</style>